import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
// @ts-nocheck
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';

/**
 * Pre-purchase confirmation. Spending points is irreversible — the previous
 * one-click claim made it easy to mis-spend, especially on mobile. This modal
 * surfaces the item preview, the price, and the resulting balance so the user
 * can back out before committing.
 *
 * Attrs:
 *   - title:     header copy (e.g. "Confirm purchase")
 *   - itemName:  what's being bought ("Golden Crown")
 *   - itemPrice: cost in points
 *   - currentBalance: user's current balance
 *   - currencyIcon:   FA icon class for the points pill
 *   - preview:   optional Mithril vnode rendered above the body (decoration
 *                preview, cover thumbnail, tier badge, etc.)
 *   - confirmLabel: optional override for the primary button copy
 *   - onConfirm: async fn called when the user confirms; receives the modal
 *                instance so it can close itself after success/failure.
 */
export default class ConfirmPurchaseModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "busy", false);
  }
  className() {
    return 'ConfirmPurchaseModal Modal--small';
  }
  title() {
    return this.attrs.title || app.translator.trans('ramon-point-system.forum.confirm.title');
  }
  content() {
    var _this$attrs$itemPrice, _this$attrs$currentBa;
    const t = (k, vars) => app.translator.trans('ramon-point-system.forum.confirm.' + k, vars);
    const price = Number((_this$attrs$itemPrice = this.attrs.itemPrice) != null ? _this$attrs$itemPrice : 0);
    const balance = Number((_this$attrs$currentBa = this.attrs.currentBalance) != null ? _this$attrs$currentBa : 0);
    const after = Math.max(0, balance - price);
    const icon = this.attrs.currencyIcon || app.forum.attribute('pointSystem.currency_icon') || 'fas fa-coins';
    return m("div", {
      className: "Modal-body ConfirmPurchaseModal-body"
    }, this.attrs.preview && m("div", {
      className: "ConfirmPurchaseModal-preview"
    }, this.attrs.preview), m("div", {
      className: "ConfirmPurchaseModal-item"
    }, m("strong", null, this.attrs.itemName || '—')), m("dl", {
      className: "ConfirmPurchaseModal-ledger"
    }, m("div", null, m("dt", null, t('price')), m("dd", null, m("i", {
      className: icon,
      "aria-hidden": "true"
    }), " ", price.toLocaleString())), m("div", null, m("dt", null, t('current_balance')), m("dd", null, m("i", {
      className: icon,
      "aria-hidden": "true"
    }), " ", balance.toLocaleString())), m("div", {
      className: "ConfirmPurchaseModal-ledger-after"
    }, m("dt", null, t('after_purchase')), m("dd", null, m("i", {
      className: icon,
      "aria-hidden": "true"
    }), " ", m("strong", null, after.toLocaleString())))), m("div", {
      className: "Form-group ConfirmPurchaseModal-actions"
    }, m(Button, {
      className: "Button",
      disabled: this.busy,
      onclick: () => this.hide()
    }, t('cancel')), m(Button, {
      className: "Button Button--primary",
      loading: this.busy,
      disabled: price > balance,
      onclick: () => this.submit()
    }, this.attrs.confirmLabel || t('confirm'))));
  }
  async submit() {
    if (this.busy || typeof this.attrs.onConfirm !== 'function') return;
    this.busy = true;
    m.redraw();
    try {
      await this.attrs.onConfirm();
      this.hide();
    } catch (e) {
      // Caller surfaces its own alert — we just stop spinning.
    } finally {
      this.busy = false;
      m.redraw();
    }
  }
}
flarum.reg.add('ramon-point-system', 'forum/components/ConfirmPurchaseModal', ConfirmPurchaseModal);